"use client";

import { useEffect, useSyncExternalStore } from "react";
import {
  captureAdSessionFromLocation,
  getAdSessionSnapshot,
  subscribeAdSession,
} from "@/lib/ad-session";

/**
 * True when this visitor arrived from Google Ads (gclid / gbraid / wbraid /
 * gad_source / utm_source=Google_Ads) and the persisted ad-session is still valid.
 *
 * Reads `localStorage.pickcel_is_ad_session` (90-day TTL). Does not use
 * `useSearchParams()` — that API is empty on `force-static` pages, which is
 * why trial CTAs previously ignored a correctly-set session flag.
 */
export function useIsAdLanding() {
  const isAdLanding = useSyncExternalStore(
    subscribeAdSession,
    getAdSessionSnapshot,
    () => false
  );

  useEffect(() => {
    captureAdSessionFromLocation();
  }, []);

  return isAdLanding;
}
